import { render, staticRenderFns } from "./PdpProductImagePanel.vue?vue&type=template&id=65f45732&"
import script from "./PdpProductImagePanel.vue?vue&type=script&lang=js&"
export * from "./PdpProductImagePanel.vue?vue&type=script&lang=js&"
import style0 from "./PdpProductImagePanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports